import { getCurrentPosition } from '../common/getCurrentPosition';
import { mapState, mapActions } from 'vuex';
export default {
  computed: {
    ...mapState('orderGeneral', {
      currentPosition: state => state.currentPosition
    })
  },
  watch: {
    taskDetail: {
      handler(newVal) {
        if (newVal) {
          this.setTaskDetail(newVal);
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    ...mapActions('orderGeneral', ['setCurrentPosition', 'setTaskDetail']),
    // 获取当前位置
    async getCurrentPosition() {
      try {
        const currentPosition = await getCurrentPosition();
        this.setCurrentPosition(currentPosition);
      } catch (error) {
        console.log(error);
      }
    }
  }

};
